import React from 'react';

function Logo({ className }) {
  return (
    <svg
      className={className}
      viewBox="0 0 210 50"
      xmlns="http://www.w3.org/2000/svg"
      style={{ overflow: 'visible' }}
    >
      {/* Original logo elements */}
      <rect x="0" y="0" width="10" height="10" fill="#000000"></rect>
      <rect x="0" y="20" width="10" height="20" fill="#000000"></rect>

      <rect x="20" y="10" width="10" height="30" fill="#000000"></rect>
      <rect x="20" y="10" width="30" height="10" fill="#000000"></rect>
      <rect x="40" y="10" width="10" height="30" fill="#000000"></rect>
      <rect x="20" y="30" width="30" height="10" fill="#000000"></rect>

      <rect x="60" y="10" width="10" height="40" fill="#000000"></rect>
      <rect x="60" y="10" width="30" height="10" fill="#000000"></rect>
      <rect x="60" y="30" width="30" height="10" fill="#000000"></rect>
      <rect x="80" y="10" width="10" height="30" fill="#000000"></rect>

      <rect x="100" y="10" width="10" height="40" fill="#000000"></rect>
      <rect x="100" y="10" width="30" height="10" fill="#000000"></rect>
      <rect x="100" y="30" width="30" height="10" fill="#000000"></rect>
      <rect x="120" y="10" width="10" height="30" fill="#000000"></rect>

      {/* Pulsating waves */}
      <circle
        cx="145"
        cy="35"
        r="2"
        fill="none"
        stroke="#00ff00"
        strokeWidth="1"
        opacity="0.7"
      >
        <animate
          attributeName="r"
          from="2"
          to="20"
          dur="4s"
          begin="0s"
          repeatCount="indefinite"
        />
        <animate
          attributeName="opacity"
          from="0.7"
          to="0.0"
          dur="4s"
          begin="0s"
          repeatCount="indefinite"
        />
      </circle>

      <circle
        cx="145"
        cy="35"
        r="4"
        fill="none"
        stroke="#00ff00"
        strokeWidth="1"
        opacity="0.4"
      >
        <animate
          attributeName="r"
          from="4"
          to="50"
          dur="2s"
          begin="0s"
          repeatCount="indefinite"
        />
        <animate
          attributeName="opacity"
          from="0.4"
          to="0"
          dur="2s"
          begin="0s"
          repeatCount="indefinite"
        />
      </circle>

      {/* Central green dot */}
      <rect x="140" y="30" width="10" height="10" fill="#00ff00"></rect>

      <rect x="160" y="0" width="10" height="10" fill="#000000"></rect>
      <rect x="160" y="20" width="10" height="20" fill="#000000"></rect>

      <rect x="180" y="10" width="10" height="30" fill="#000000"></rect>
      <rect x="180" y="10" width="30" height="10" fill="#000000"></rect>
      <rect x="200" y="10" width="10" height="30" fill="#000000"></rect>
      <rect x="180" y="30" width="30" height="10" fill="#000000"></rect>
    </svg>
  );
}

export default Logo;
